import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

// Social media icons as SVG components for crisp rendering
const DiscordIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
  </svg>
);

const InstagramIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const FacebookIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const TikTokIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
);

export function SocialMediaWidget() {
  const [isExpanded, setIsExpanded] = useState(false);

  const socialLinks = [
    { 
      name: 'Discord', 
      icon: DiscordIcon, 
      url: 'https://discord.gg/supremics',
      color: 'hover:bg-[#5865F2] hover:text-white',
      bgColor: 'bg-[#5865F2]'
    },
    { 
      name: 'Instagram', 
      icon: InstagramIcon, 
      url: 'https://instagram.com/supremics',
      color: 'hover:bg-gradient-to-br hover:from-[#833AB4] hover:via-[#FD1D1D] hover:to-[#F77737] hover:text-white',
      bgColor: 'bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#F77737]'
    },
    { 
      name: 'Facebook', 
      icon: FacebookIcon, 
      url: 'https://facebook.com/supremics',
      color: 'hover:bg-[#1877F2] hover:text-white',
      bgColor: 'bg-[#1877F2]'
    },
    { 
      name: 'TikTok', 
      icon: TikTokIcon, 
      url: 'https://tiktok.com/@supremics',
      color: 'hover:bg-black hover:text-white',
      bgColor: 'bg-black'
    },
  ];

  return (
    <div 
      className="fixed right-0 top-1/2 -translate-y-1/2 z-40 flex items-center"
      data-testid="social-media-widget"
    >
      {/* Expanded Panel */}
      <div 
        className={`flex flex-col gap-2 p-2 bg-[var(--surface)]/95 backdrop-blur-sm border border-[var(--border)] border-r-0 rounded-l-xl shadow-lg transition-all duration-300 ${
          isExpanded ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-full pointer-events-none'
        }`}
      >
        <p className="text-xs text-[var(--text-secondary)] text-center px-2 mb-1">Follow Us</p>
        {socialLinks.map((social) => (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center gap-3 px-4 py-2.5 rounded-lg bg-[var(--background)] border border-[var(--border)] transition-all ${social.color}`}
            data-testid={`social-${social.name.toLowerCase()}`}
          >
            <social.icon size={18} />
            <span className="text-sm font-medium">{social.name}</span>
          </a>
        ))}
      </div>

      {/* Toggle Button - Always Visible */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className={`flex flex-col gap-1.5 p-3 rounded-l-xl border border-r-0 border-[var(--border)] shadow-lg transition-all ${
          isExpanded 
            ? 'bg-[var(--primary)] text-white' 
            : 'bg-[var(--surface)]/95 backdrop-blur-sm hover:bg-[var(--surface-highlight)]'
        }`}
        aria-label={isExpanded ? 'Close social links' : 'Open social links'}
      >
        {isExpanded ? (
          <X size={20} />
        ) : (
          <>
            <DiscordIcon size={16} />
            <InstagramIcon size={16} />
            <FacebookIcon size={16} />
            <TikTokIcon size={16} />
          </>
        )}
      </button>
    </div>
  );
}

// Compact version for footer or other placements
export function SocialMediaLinks({ className = '' }) {
  const socialLinks = [
    { name: 'Discord', icon: DiscordIcon, url: 'https://discord.gg/supremics', hoverColor: 'hover:text-[#5865F2]' },
    { name: 'Instagram', icon: InstagramIcon, url: 'https://instagram.com/supremics', hoverColor: 'hover:text-[#E4405F]' },
    { name: 'Facebook', icon: FacebookIcon, url: 'https://facebook.com/supremics', hoverColor: 'hover:text-[#1877F2]' },
    { name: 'TikTok', icon: TikTokIcon, url: 'https://tiktok.com/@supremics', hoverColor: 'hover:text-white' },
  ];

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {socialLinks.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`w-10 h-10 rounded-full bg-[var(--background)] border border-[var(--border)] flex items-center justify-center transition-all hover:border-[var(--primary)] ${social.hoverColor}`}
          aria-label={social.name}
        >
          <social.icon size={18} />
        </a>
      ))}
    </div>
  );
}

export default SocialMediaWidget;
